import { render, staticRenderFns } from "./LanguageSelectBlock.vue?vue&type=template&id=74073d02&scoped=true&"
import script from "./LanguageSelectBlock.vue?vue&type=script&lang=js&"
export * from "./LanguageSelectBlock.vue?vue&type=script&lang=js&"
import style0 from "./LanguageSelectBlock.vue?vue&type=style&index=0&id=74073d02&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74073d02",
  null
  
)

export default component.exports